import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';
import './HeroSection.css';
import './HeroMobileCover.css';
import heroImage from '../assets/images/hero.jpg';

const DEFAULT_CREDENTIALS = [
  "6+ Years of Legal Experience",
  "LLM (Distinction) · Queen Mary University of London",
  "Mentor",
  "Clarity · Strategy · Growth",
];

function HeroSection() {
  const [credentials, setCredentials] = useState(DEFAULT_CREDENTIALS);
  const [portrait, setPortrait] = useState(heroImage);

  useEffect(() => {
    getDoc(doc(db, 'hero_config', 'main'))
      .then(snap => {
        if (snap.exists()) {
          const data = snap.data();
          if (Array.isArray(data.credentials) && data.credentials.length) setCredentials(data.credentials);
          if (data.heroImage) setPortrait(data.heroImage);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="hero-layout">
      <div className="hero-frame">
        <div className="hero-wrapper">
          {/* Main Content Card */}
          <div className="hero-left-center">
            <div className="hero-content-row">
              {/* Logo Section — same crop as the navbar, for consistency */}
              <div className="hero-left">
                <span className="hero-navlogo-crop" aria-hidden="true">
                  <img
                    src="/ChatGPT Image Aug 11, 2026, 09_22_14 PM.png"
                    alt="The PP Studio"
                    className="hero-navlogo-img"
                  />
                </span>
              </div>

              {/* Quote Section */}
              <div className="hero-center">
                <div className="quote-block">
                  <span className="hero-tagline">Contract Specialist</span>
                  <p className="main-quote">
                    Contracts made with Precision and Poise.&#10078;
                  </p>
                  <p className="author">
                    &ndash; Pooja Biswal
                  </p>
                  <div className="hero-cta-row">
                    <a href="#contact" className="cta-primary">Let's Connect</a>
                    <a href="/explore" className="cta-secondary">Explore</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Credentials Bar */}
            <div className="credentials-bar">
              {credentials.map((c, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <span className="cred-sep">✦</span>}
                  <span className="cred-pill">{c}</span>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Profile Image Section */}
          <div className="hero-right">
            <div className="hero-photo-meta" aria-hidden="true">
              <span>The PP Studio · London</span>
              <span>Precision · Poise</span>
            </div>
            <img
              src={portrait}
              alt="Pooja Biswal - Contract Specialist"
              className="hero-image"
              loading="eager"
              fetchPriority="high"
            />
            <button
              type="button"
              className="hero-badge hero-subscribe-cta"
              onClick={() => document.getElementById('nl-subscribe-title')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
            >
              <span className="badge-dot"></span>
              Subscribe for updates
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
